import { Link } from "react-router-dom";
import {
  SITE_PAGE_SHELL_CLASS,
  GLASS_PANEL_CLASS,
  SitePageAtmosphere,
  SITE_PAGE_BODY_PADDING_TOP,
} from "./SitePageChrome.jsx";

const UnauthorizedPage = () => {
  return (
    <div className={`${SITE_PAGE_SHELL_CLASS} flex flex-col justify-center items-center px-4 ${SITE_PAGE_BODY_PADDING_TOP}`}>
      <SitePageAtmosphere />

      <div className="relative z-10 w-full max-w-lg text-center">
        <div className={`${GLASS_PANEL_CLASS} p-8 sm:p-12 md:p-16 border border-white/[0.08] bg-white/[0.03] backdrop-blur-md shadow-2xl`}>
          {/* Lock Icon / Unauthorized Header */}
          <div className="relative mb-6 flex justify-center">
            <div className="w-24 h-24 rounded-full bg-amber-500/10 flex items-center justify-center border border-amber-500/25 relative animate-pulse-slow">
              <svg className="w-12 h-12 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <div className="absolute inset-0 blur-2xl opacity-20 bg-amber-500 rounded-full scale-50 pointer-events-none"></div>
          </div>

          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 tracking-tight">
            Access Denied
          </h2>

          <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-8">
            You do not currently have access to this. Please contact{" "}
            <a
              href="mailto:shreyashran@gmail.com"
              className="text-cyan-400 hover:text-cyan-300 font-semibold underline transition-colors"
            >
              Shreyash
            </a>{" "}
            if you believe this is a mistake.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-cyan-400 to-pink-400 text-gray-900 font-bold rounded-xl shadow-lg hover:shadow-cyan-400/20 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300"
            >
              Return Home
            </Link>
            <Link
              to="/faq"
              className="w-full sm:w-auto px-6 py-3 border border-white/20 text-white font-bold rounded-xl hover:border-cyan-400 hover:bg-cyan-400/10 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300"
            >
              View FAQ
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse-slow {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.03); opacity: 0.95; }
        }
        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default UnauthorizedPage;
